<template>
    <div class="offset-lg-2 col-lg-8 col-12 m-auto">
        <Card>
            <h1>{{$t('support.tickets.create')}}</h1>
            <div class="align-start justify-content-between column col-12">
                <form>
                    <base-input
                        v-model="ticket.title"
                        v-validate="'required'"
                        :name="$t('common.title')"
                        type="text"
                        :placeholder="$t('support.tickets.title')"
                        aria-describedby="button"
                        :error="errors.first($t('common.title'))"
                    ></base-input>
                    <plan-select
                        v-validate="'required'"
                        :name="$t('common.plans')"
                        :items="plans"
                        v-model="ticket.plan_id"
                        :error="errors.first($t('common.plans'))"
                    ></plan-select>
                    <support-departments-select
                        v-validate="'required'"
                        :name="$t('support.tickets.department')"
                        :items="departments"
                        v-model="ticket.department_id"
                        :error="errors.first($t('support.tickets.department'))"
                    ></support-departments-select>
                </form>
            </div>
            <div class="d-flex">
                <form class="col-12">
                    <Editor
                        class="nch--html-editor"
                        v-model="ticket.reply.content"
                        v-validate="'required'"
                        :name="$t('support.tickets.reply')"
                    ></Editor>
                    <base-button :disabled="disabled" @click="create(ticket.reply)" type="success">
                        <span class="fas fa-paper-plane mr-2"></span>
                        {{$t('common.send')}}
                    </base-button>
                    <base-button outline @click="modal=true" type="secondary">
                        <span
                            class="mdi"
                            :class="file && file.path ? 'mdi-check-circle-outline' : 'mdi-paperclip'"
                        >{{$t('common.attach')}}</span>
                    </base-button>
                    <UploadDropzoneModal
                        :modal="modal"
                        @close="modal=false"
                        @success="uploadSuccess"
                        v-model="file"
                    ></UploadDropzoneModal>
                </form>
            </div>
        </Card>
    </div>
</template>

<script>
import Card from '../argon/components/Cards/Card';
import BaseButton from '../argon/components/BaseButton';
import BaseInput from '../argon/components/Inputs/BaseInput';
import ticket from './TicketComponents/mixins/ticket';
import TicketReplyForm from './TicketComponents/Reply/TicketReplyForm';
import TicketReplies from './TicketComponents/Reply/TicketReplies';
import SupportDepartmentsSelect from './SupportDepartmentsComponents/SupportDepartmentsSelect';
import PlanSelect from './PlansComponents/PlanSelect';
import Editor from '../argon/components/Inputs/HtmlEditor';
import FileInput from '../argon/components/Inputs/FileInput';
import UploadDropzoneModal from './Common/Upload/UploadDropzoneModal';

export default {
    name: 'TicketCreate',

    components: {
        Card,
        BaseInput,
        TicketReplyForm,
        SupportDepartmentsSelect,
        PlanSelect,
        TicketReplies,
        BaseButton,
        Editor,
        FileInput,
        UploadDropzoneModal,
    },

    mixins: [ticket],

    props: {
        color: {
            type: Object,
            required: true,
        },
        plans: {
            type: Array,
            required: true,
        },
        departments: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            ticket: {
                title: '',
                department_id: null,
                plan_id: null,
                reply: {
                    upload: null,
                    content: '',
                },
            },
            file: null, // Mantido como objeto
            modal: false,
            disabled: false, // Adicionado
        };
    },

    methods: {
        uploadSuccess(event) {
            console.log('Evento de Upload:', event); // Para depuração

            // Define o caminho correto
            const uploadPath = event.path || event.filePath || ''; // Ajuste conforme necessário

            this.file = {
                uuid: event.hash || event.request.serverId || '', // Usando 'hash' ou 'serverId' como UUID
                progress: event.done || 100, // 'done' indica a porcentagem de conclusão
                total: event.size,
                bytesSent: event.size, // Assumindo que todo o arquivo foi enviado
                filename: event.name, // 'name' da API corresponde a 'filename'
                chunked: false, // Assumindo upload não fragmentado
                totalChunkCount: 1, // Assumindo um único fragmento
                path: uploadPath, // Caminho correto
                host: event.host,
                hash: event.hash,
                type: event.type,
                mime: event.mime,
                size: event.size,
                original_file: event.original_file,
                width: event.width,
                height: event.height,
                uploadLimits: {
                    diskUsage: event.uploadLimits.diskUsage,
                    diskUpload: event.uploadLimits.diskUpload,
                    diskSpace: event.uploadLimits.diskSpace,
                },
            };
        },

        async create(reply) {
            const valid = await this.$validator.validateAll();

            if (valid) {
                this.disabled = true; // Desativa o botão

                if (this.file) { // Verifica se há um arquivo anexado
                    // Certifique-se de que 'path' está definido
                    if (!this.file.path) {
                        this.$notify({
                            type: 'danger',
                            message: 'O caminho do arquivo está indefinido.',
                        });
                        this.disabled = false; // Reativa o botão
                        return;
                    }

                    reply.upload = {
                        status: 1,
                        ...this.file, // Espalha as propriedades do arquivo
                    };
                    this.ticket.reply = reply;

                    // Log para verificar a estrutura
                    console.log('Payload de Upload:', reply.upload);
                }

                if (reply.upload && reply.upload.chunked) { // Verifica se 'chunked' está definido
                    await this.sendCreateTicketChunked(reply);
                    this.disabled = false; // Reativa o botão
                    return;
                }

                this.$loading.show();
                console.log('Payload Enviado:', {
                    ...this.ticket,
                    reply,
                }); // Log do payload
                return window.axios
                    .post('/api/app/tickets/save', {
                        ...this.ticket,
                        reply,
                    })
                    .then((res) => {
                        this.$notify({
                            type: 'success',
                            message: this.$t('common.response.success'),
                        });
                        setTimeout(() => {
                            location.href = '/app/tickets';
                        }, 200);
                    })
                    .catch((err) => {
                        this.$notify({
                            type: 'danger',
                            message: this.$t('common.response.error'),
                        });
                        console.log(err);
                    })
                    .finally(() => {
                        this.$loading.close();
                        this.disabled = false; // Reativa o botão
                    });
            }
        },

        async sendCreateTicketChunked(reply) {
            this.ticket = {
                department_id: this.ticket.department_id,
                plan_id: this.ticket.plan_id,
                reply: {
                    content: reply.content,
                    upload: {
                        status: reply.upload.status,
                        uuid: reply.upload.uuid,
                        progress: reply.upload.progress,
                        total: reply.upload.total,
                        bytesSent: reply.upload.bytesSent,
                        filename: reply.upload.filename,
                        chunked: reply.upload.chunked,
                        totalChunkCount: reply.upload.totalChunkCount,
                        path: reply.upload.path,
                        host: reply.upload.host,
                        hash: reply.upload.hash,
                        type: reply.upload.type,
                        mime: reply.upload.mime,
                        size: reply.upload.size,
                        original_file: reply.upload.original_file,
                        width: reply.upload.width,
                        height: reply.upload.height,
                        uploadLimits: {
                            diskUsage: reply.upload.uploadLimits.diskUsage,
                            diskUpload: reply.upload.uploadLimits.diskUpload,
                            diskSpace: reply.upload.uploadLimits.diskSpace,
                        },
                    },
                },
                title: this.ticket.title,
            };

            reply = this.ticket.reply;

            this.$loading.show();
            console.log('Payload Chunked Enviado:', {
                ...this.ticket,
                reply,
            }); // Log do payload chunked
            return window.axios
                .post('/api/app/tickets/save', {
                    ...this.ticket,
                    reply,
                })
                .then((res) => {
                    this.$notify({
                        type: 'success',
                        message: this.$t('common.response.success'),
                    });
                    setTimeout(() => {
                        location.href = '/app/tickets';
                    }, 200);
                })
                .catch((err) => {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('common.response.error'),
                    });
                    console.log(err);
                })
                .finally(() => {
                    this.$loading.close();
                    this.disabled = false; // Reativa o botão
                });
        },
    },
};
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn :deep(i) {
  padding: 0 3px;
}
.pill {
  border-radius: 40px;
}
</style>
